// extracted by mini-css-extract-plugin
module.exports = {"image":"Description_image____U6V","description":"Description_description__Gxxu9","richTextImg":"Description_richTextImg__kCYX_"};